// ════════════════════════════════════════════════════════════════════
// Glass-i — Stage SALES-RECEIPTS-1 · Customer Receipts API client.
// Base: /api/erp/accounts/customer-receipts. Mirrors the proformaApi
// axios + unwrap() pattern. Sales records DRAFT receipts; Accounts posts.
// ════════════════════════════════════════════════════════════════════

import client from '../../../../api/client';

const BASE = '/api/erp/accounts/customer-receipts';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined ? resp.data.data : (resp ? resp.data : null);
}
const enc = encodeURIComponent;

export const customerReceiptsApi = {
  list: (params = {}) => client.get(BASE, { params }).then(unwrap),
  create: (payload) => client.post(BASE, payload).then(unwrap),
  post: (id) => client.post(`${BASE}/${enc(id)}/post`).then(unwrap),
  cancel: (id, reason) => client.post(`${BASE}/${enc(id)}/cancel`, { reason }).then(unwrap),
  position: (customerId, proformaId) =>
    client.get(`${BASE}/position/${enc(customerId)}`, { params: proformaId ? { proformaId } : {} }).then(unwrap),

  // Cash/Bank ledger dropdown (shared accounts endpoint) — the deposit account.
  cashBankLedgers: () => client.get('/api/erp/accounts/ledgers/cash-bank').then(unwrap),

  // Stage SALES-RECEIPTS-2 — allocate an on-account advance across confirmed PIs.
  allocationContext: (id) => client.get(`${BASE}/${enc(id)}/allocation-context`).then(unwrap),
  allocate: (id, allocations) => client.post(`${BASE}/${enc(id)}/allocate`, { allocations }).then(unwrap)
};

export default customerReceiptsApi;
